import { Block, type Document } from '@gitbook/slate';

import { BLOCK_OPENAPI, type BlockOpenAPIContentReference, type BlockOpenAPIData } from '../types';

/**
 * Create an OpenAPI block referencing a file or url.
 */
export function createBlockWithRef({
    ref,
    path,
    method,
    expanded,
    fullWidth,
}: {
    ref: BlockOpenAPIContentReference;
    path: string;
    method: string;
    expanded?: boolean;
    fullWidth?: boolean;
}): Block {
    return Block.createVoid({
        type: BLOCK_OPENAPI,
        data: {
            ref,
            ...(typeof path !== 'undefined' ? { path } : {}),
            ...(typeof method !== 'undefined' ? { method } : {}),
            ...(typeof expanded !== 'undefined' ? { expanded } : {}),
            ...(typeof fullWidth !== 'undefined' ? { fullWidth } : {}),
        },
    });
}

/**
 * Get the (probably) most recently used Swagger reference in a given document.
 *
 * Looks at each block from the bottom to the top, and returns the first OpenAPI reference
 * it finds. If no reference is found, returns null.
 */
export function getProbableRef(document: Document): BlockOpenAPIContentReference | null {
    const blocks = document.getBlocksByTypeAsArray(BLOCK_OPENAPI);

    if (blocks.length === 0) {
        return null;
    }

    const reversed = blocks.reverse();

    for (const block of reversed) {
        if (block.object !== 'block') {
            continue;
        }

        const data = block.data.toObject<BlockOpenAPIData>();

        if ('ref' in data && data.ref) {
            return data.ref;
        }
    }

    return null;
}
